// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import getSiteValues from './getSiteValues'
import RenderSiteCell from './RenderSiteCell'

// This is a generic component which renders the two sub-rows
// that are seen on the path summary tables.
// This finds its specified value on CWM and assigns them to state.
// You can customize any of these methods or add your own if you simply extend this class.
// see ./FormatElevation for an example of this.

const PathSummaryCell = ({ columnKey, idRoot, rowData }) => {
  const {
    site1Value,
    site2Value,
  } = getSiteValues(columnKey, rowData)

  return (
    <div className={'path-summary-cell'}>
      <RenderSiteCell
        contents={site1Value}
        label={`site-1-${columnKey}`}
        id={`${idRoot}-site-1`} />
      <RenderSiteCell
        contents={site2Value}
        label={`site-2-${columnKey}`}
        id={`${idRoot}-site-2`} />
    </div>
  )
}

PathSummaryCell.propTypes = {
  columnKey: string.isRequired,
  idRoot: string.isRequired,
  rowData: object.isRequired,
}

export default PathSummaryCell
